const STORAGE_KEY = 'jncquoi.pendingDeepLink';

/**
 * Remembers a resolved deep-link route so it can survive an interstitial (login,
 * PIN/biometric re-verification, the post-unlock Welcome screen) that would otherwise
 * clobber the URL with a hardcoded redirect to `/`. `sessionStorage`, not `localStorage`:
 * this only needs to survive a few seconds within the same already-running JS process —
 * never across an actual process kill, where a fresh cold start correctly begins with
 * nothing remembered until the next deep link writes something.
 */
export function rememberDeepLinkTarget(path: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch (error) {
    console.warn('rememberDeepLinkTarget: could not persist target:', error);
  }
}

/** One-shot: reads the remembered target and clears it, so it's never replayed twice. */
export function consumeDeepLinkTarget(): string | undefined {
  try {
    const path = sessionStorage.getItem(STORAGE_KEY);
    if (path) sessionStorage.removeItem(STORAGE_KEY);
    return path ?? undefined;
  } catch (error) {
    console.warn('consumeDeepLinkTarget: could not read target:', error);
    return undefined;
  }
}
